import { DRAGONBONES_PATH } from 'Constants/Dragonbones';
import { IGameState } from 'State/Game/IGameState';
import { IAPStateHelper } from 'State/Player/IAP/IAPStateHelper';
import { getHighestLevelCompleted } from 'State/Player/PlayerLevelHelper';
import { EventType } from 'Utility/Helpers/Events/EventType';
import { IEventOfferData } from 'Utility/Helpers/IAP/IEventOfferData';
import { OfferType } from 'Utility/Helpers/IAP/Offers/OfferTypes/OfferType';
import { PopupOffersOfType, PopupOfferType } from 'Utility/Helpers/IAP/PopupOffers';
import { ProductId } from 'Utility/Product';
import { areDBResourcesLoaded, addDragonbonesResources } from 'Utility/Resource/ResourceHelper';

export const EVENT_OFFERS: Record<keyof PopupOffersOfType<PopupOfferType.EVENT_OFFER>, IEventOfferData> = {
    [EventType.EASTER_2025]: {
        condition: (state: IGameState): boolean => {
            const highestLevel = getHighestLevelCompleted(state.playerState);
            const hasPurchasedFinal = [
                ProductId.EASTER_2025_v1_3,
                ProductId.EASTER_2025_v2_3,
                ProductId.EASTER_2025_v3_3,
                ProductId.EASTER_2025_v4_3,
            ].some(productId => IAPStateHelper.hasPurchasedProduct(state, productId));
            return highestLevel >= 22 && !hasPurchasedFinal;
        },
        queueAssets: () => {
            if (!areDBResourcesLoaded('easter_offer')) {
                addDragonbonesResources('easter_offer', `${DRAGONBONES_PATH}/Events/Easter/`);
            }
            if (!areDBResourcesLoaded('easter_gift_exp')) {
                addDragonbonesResources('easter_gift_exp', `${DRAGONBONES_PATH}/Events/Easter/`);
            }
        },
        buttonCacheKey: 'easter_offer_icon',
        productId: [],
        offer: {
            tiers: [
                {
                    type: OfferType.MULTI,
                    requirements: { max: 0 },
                    products: [
                        { productId: ProductId.EASTER_2025_v1_1 },
                        { productId: ProductId.EASTER_2025_v1_2 },
                        { productId: ProductId.EASTER_2025_v1_3 },
                    ],
                },
                {
                    type: OfferType.MULTI,
                    requirements: { max: 85 },
                    products: [
                        { productId: ProductId.EASTER_2025_v2_1 },
                        { productId: ProductId.EASTER_2025_v2_2 },
                        { productId: ProductId.EASTER_2025_v2_3 },
                    ],
                },
                {
                    type: OfferType.MULTI,
                    requirements: { max: 250 },
                    products: [
                        { productId: ProductId.EASTER_2025_v3_1 },
                        { productId: ProductId.EASTER_2025_v3_2 },
                        { productId: ProductId.EASTER_2025_v3_3 },
                    ],
                },
                {
                    type: OfferType.MULTI,
                    products: [
                        { productId: ProductId.EASTER_2025_v4_1 },
                        { productId: ProductId.EASTER_2025_v4_2 },
                        { productId: ProductId.EASTER_2025_v4_3 },
                    ],
                },
            ],
        },
    },
};
